/* Shatrin x Other Levels launch promotion — shared widget for the homepage section,
   the /pages/shatrin landing page and the announcement bar.

   • "Get my reward code" asks Shatrin's public endpoint for a short referral code
     (OL-XXXXXX). The code is a random handle — no personal data ever goes in a URL.
   • The same browser gets the same code back while it is valid (refresh / double
     click never mints a second one).
   • The visitor installs Shatrin and enters the code (or opens it with the
     "Open Shatrin" button, which pre-fills it). Rewards are decided by Shatrin's
     server after sign-up — nothing on this page can grant a discount.
   • Counters: impressions / clicks / store clicks go to Shatrin (anonymous daily
     totals) and, when present, to GA4 (gtag) and Shopify customer events. */
(function () {
  'use strict';
  var STORE_KEY = 'shp_code_v1';
  var IOS_URL = 'https://apps.apple.com/app/shatrin/id6778334712';
  var PLAY_URL = 'https://play.google.com/store/apps/details?id=com.shatrin.app';
  var CODE_RE = /^OL-[23456789ABCDEFGHJKMNPQRSTUVWXYZ]{6}$/;

  function readSaved() {
    try {
      var v = JSON.parse(localStorage.getItem(STORE_KEY) || 'null');
      if (v && CODE_RE.test(v.code) && new Date(v.expires_at) > new Date()) return v;
    } catch (e) { /* storage blocked */ }
    return null;
  }
  function save(v) { try { localStorage.setItem(STORE_KEY, JSON.stringify(v)); } catch (e) { /* ignore */ } }
  function forget() { try { localStorage.removeItem(STORE_KEY); } catch (e) { /* ignore */ } }

  function isMobile() { return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent || ''); }
  function isIOS() { return /iPhone|iPad|iPod/i.test(navigator.userAgent || ''); }

  function post(endpoint, body) {
    return fetch(endpoint, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body), credentials: 'omit', keepalive: body.action === 'track'
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) { j.__status = r.status; return j; });
    });
  }

  function track(endpoint, event, placement, extra) {
    try { if (typeof window.gtag === 'function') window.gtag('event', event, Object.assign({ placement: placement, campaign: 'shatrin_launch' }, extra || {})); } catch (e) { /* ignore */ }
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(event, { placement: placement }); } catch (e) { /* ignore */ }
    if (endpoint) post(endpoint, { action: 'track', event: event, placement: placement }).catch(function () {});
  }

  function fmtDate(iso) {
    try { return new Date(iso).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' }); } catch (e) { return ''; }
  }

  function playUrlWith(code) {
    // Play passes this through to the app on first launch (Install Referrer). Harmless if unused.
    return PLAY_URL + '&referrer=' + encodeURIComponent('utm_source=other_levels&utm_campaign=shatrin_launch' + (code ? '&ol_code=' + code : ''));
  }

  function Widget(root) {
    this.root = root;
    this.endpoint = root.getAttribute('data-endpoint');
    this.placement = root.getAttribute('data-placement') || 'other';
    this.panel = root.querySelector('[data-shp-panel]');
    this.getBtns = root.querySelectorAll('[data-shp-get]');
    this.busy = false;
    this.bind();
  }

  Widget.prototype.bind = function () {
    var self = this;
    Array.prototype.forEach.call(this.getBtns, function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); self.getCode(true); });
    });
    this.root.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('[data-shp-store]') : null;
      if (a) {
        var store = a.getAttribute('data-shp-store');
        track(self.endpoint, store === 'ios' ? 'shatrin_appstore_click' : 'shatrin_playstore_click', self.placement);
      }
      var c = e.target.closest ? e.target.closest('[data-shp-copy]') : null;
      if (c) { e.preventDefault(); self.copy(c); }
      var link = e.target.closest ? e.target.closest('[data-shp-cta]') : null;
      if (link) track(self.endpoint, 'shatrin_promo_click', self.placement);
    });
    // Store badges outside the code panel still carry the saved code when there is one.
    this.refreshStoreLinks((readSaved() || {}).code);
    var saved = readSaved();
    if (saved && this.panel && this.root.hasAttribute('data-shp-autoshow')) this.render(saved);
  };

  Widget.prototype.refreshStoreLinks = function (code) {
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-shp-store="android"]'), function (a) { a.href = playUrlWith(code); });
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-shp-store="ios"]'), function (a) { a.href = IOS_URL; });
  };

  Widget.prototype.setBusy = function (on) {
    this.busy = on;
    Array.prototype.forEach.call(this.getBtns, function (b) { b.disabled = on; b.setAttribute('aria-busy', on ? 'true' : 'false'); });
  };

  Widget.prototype.getCode = function (userClicked) {
    var self = this;
    if (this.busy) return;
    if (userClicked) track(this.endpoint, 'shatrin_promo_click', this.placement);
    var saved = readSaved();
    this.setBusy(true);
    this.error('');
    post(this.endpoint, { action: 'click', placement: this.placement, existing_code: saved ? saved.code : null })
      .then(function (j) {
        if (j.__status === 200 && CODE_RE.test(j.code)) {
          var v = { code: j.code, expires_at: j.expires_at };
          save(v);
          self.render(v);
        } else if (j.error === 'rate_limited') {
          self.error('Too many requests from this connection. Please try again in an hour.');
        } else if (j.error === 'campaign_inactive') {
          self.error('The Shatrin launch offer has ended. Thank you for your interest!');
        } else {
          self.error('We could not create your code right now. Please try again in a moment.');
        }
      })
      .catch(function () { self.error('We could not reach Shatrin. Check your connection and try again.'); })
      .then(function () { self.setBusy(false); });
  };

  Widget.prototype.error = function (msg) {
    var el = this.root.querySelector('[data-shp-error]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = !msg;
  };

  Widget.prototype.render = function (v) {
    if (!this.panel) return;
    var p = this.panel;
    p.hidden = false;
    var set = function (sel, fn) { Array.prototype.forEach.call(p.querySelectorAll(sel), fn); };
    set('[data-shp-code]', function (el) { el.textContent = v.code; });
    set('[data-shp-expiry]', function (el) { el.textContent = 'Code valid until ' + fmtDate(v.expires_at) + ' — enter it in Shatrin after you sign up.'; });
    set('[data-shp-copy]', function (el) { el.setAttribute('data-shp-copy', v.code); });
    set('[data-shp-qr]', function (img) {
      if (isMobile()) { img.closest('figure').hidden = true; return; }
      img.src = this.endpoint + '?qr=' + encodeURIComponent(v.code);
    }.bind(this));
    set('[data-shp-open]', function (a) {
      // Deep link only makes sense on a phone that may already have the app.
      if (!isMobile()) { a.hidden = true; return; }
      a.hidden = false;
      a.href = 'shatrin://other-levels?code=' + encodeURIComponent(v.code);
    });
    // Put the relevant store first on a phone.
    if (isMobile()) {
      set('[data-shp-stores]', function (wrap) {
        var first = wrap.querySelector(isIOS() ? '[data-shp-store="ios"]' : '[data-shp-store="android"]');
        if (first) wrap.insertBefore(first, wrap.firstChild);
      });
    }
    this.refreshStoreLinks(v.code);
    Array.prototype.forEach.call(this.getBtns, function (b) { if (b.hasAttribute('data-shp-hide-after')) b.hidden = true; });
  };

  Widget.prototype.copy = function (btn) {
    var code = btn.getAttribute('data-shp-copy');
    var done = function () {
      var old = btn.textContent;
      btn.textContent = 'Copied ✓';
      setTimeout(function () { btn.textContent = old; }, 1800);
    };
    track(this.endpoint, 'shatrin_code_copied', this.placement);
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, function () { window.prompt('Copy your code:', code); });
    } else {
      window.prompt('Copy your code:', code);
    }
  };

  function observeImpressions(root, endpoint, placement) {
    if (!('IntersectionObserver' in window)) return;
    var seen = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!seen && en.isIntersecting && en.intersectionRatio >= 0.4) {
          seen = true; io.disconnect();
          track(endpoint, 'shatrin_promo_impression', placement);
        }
      });
    }, { threshold: [0.4] });
    io.observe(root);
  }

  function fillCountries(roots, endpoint) {
    if (!roots.length || !endpoint) return;
    post(endpoint, { action: 'config' }).then(function (j) {
      if (j.__status !== 200) return;
      if (Array.isArray(j.countries) && j.countries.length) {
        roots.forEach(function (r) {
          Array.prototype.forEach.call(r.querySelectorAll('[data-shp-countries]'), function (el) { el.textContent = j.countries.join(', '); });
        });
      }
      if (j.campaign_active === false) {
        roots.forEach(function (r) {
          Array.prototype.forEach.call(r.querySelectorAll('[data-shp-get]'), function (b) { b.hidden = true; });
          Array.prototype.forEach.call(r.querySelectorAll('[data-shp-ended]'), function (el) { el.hidden = false; });
        });
      }
    }).catch(function () {});
  }

  function init() {
    var roots = Array.prototype.slice.call(document.querySelectorAll('[data-shp]'));
    if (!roots.length) return;
    var endpoint = roots[0].getAttribute('data-endpoint');
    roots.forEach(function (root) {
      if (root.__shp) return;
      root.__shp = new Widget(root);
      observeImpressions(root, root.getAttribute('data-endpoint'), root.getAttribute('data-placement') || 'other');
    });
    fillCountries(roots, endpoint);

    // Landing page: ?c=OL-XXXXXX arrives from the desktop QR — continue with that code.
    var landing = document.querySelector('[data-shp][data-placement="landing"]');
    if (landing) {
      track(endpoint, 'shatrin_landing_view', 'landing');
      var qp = new URLSearchParams(location.search).get('c');
      var fromQr = qp ? qp.toUpperCase() : null;
      if (fromQr && CODE_RE.test(fromQr)) {
        post(endpoint, { action: 'status', code: fromQr }).then(function (j) {
          if (j.status === 'valid') {
            save({ code: j.code, expires_at: j.expires_at });
            landing.__shp.render({ code: j.code, expires_at: j.expires_at });
            var target = landing.querySelector('[data-shp-panel]');
            if (target && target.scrollIntoView) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } else if (j.status === 'claimed' || j.status === 'expired') {
            forget();
          }
        }).catch(function () {});
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
